import { gql } from '@apollo/client';

const GetCacheDriverVehicles = gql`query getCacheDriverVehicles {
  vehicles @client
}`;

export default GetCacheDriverVehicles;
